import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { ClientItemId } from 'owa-client-ids';
import showInImmersiveReader from 'owa-immersive-reader-store/lib/actions/showInImmersiveReader';
import { ActionSource } from 'owa-analytics-actions';
import { action } from 'satcheljs/lib/legacy';

export default action('showConversationInImmersiveReader')(async function(
    conversationId: ClientItemId,
    actionSource: ActionSource
) {
    const itemId = await getLatestNonDraftItemIdFromConversation(conversationId);

    if (itemId) {
        showInImmersiveReader(itemId, actionSource);
    }
});
